import { Interview } from '@csh/ui/api/types/interview';
import React from 'react';

export interface UpdateInterviewModalProps {
  isOpen: boolean;
  toggle: () => void;
  item: Interview;
}

export const UpdateInterviewModal = () => {
  return <></>;
};
